var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDef({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.82,
    height: 100.82,
    viewBox: "0 0 100.82 100.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-circle-solid",
    d: "M50.41,8a50.41,50.41,0,1,0,50.41,50.41A50.4,50.4,0,0,0,50.41,8Zm0,19.514A17.887,17.887,0,1,1,32.523,45.4,17.888,17.888,0,0,1,50.41,27.514Zm0,69.924A38.951,38.951,0,0,1,20.632,83.575,22.663,22.663,0,0,1,40.653,71.419a4.974,4.974,0,0,1,1.443.224,26.913,26.913,0,0,0,8.314,1.4,26.811,26.811,0,0,0,8.314-1.4,4.974,4.974,0,0,1,1.443-.224A22.663,22.663,0,0,1,80.189,83.575,38.951,38.951,0,0,1,50.41,97.437Z",
    transform: "translate(0 -8)",
    fill: "#444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDef);
export default __webpack_public_path__ + "static/media/userDef.c22dfde42f4caac3c54cb6fa054e2120.svg";
export { ForwardRef as ReactComponent };